import SlimmingWorldLogo from './SlimmingWorldLogo';

export default SlimmingWorldLogo;
